<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentfs" id="ch00_fm02"><a id="page_ii"></a><span class="small">SEXUAL CULTURES</span></p>
<p class="noindent">General Editors: José Esteban Muñoz and Ann Pellegrini</p>
<p class="noindentfs"><em>Times Square Red, Times Square Blue</em><br/>Samuel R. Delany</p>
<p class="noindentfs"><em>Private Affairs: Critical Ventures in<br/>the Culture of Social Relations</em><br/>Phillip Brian Harper</p>
<p class="noindentfs"><em>In Your Face: 9 Sexual Studies</em><br/>Mandy Merck</p>
<p class="noindentfs"><em>Tropics of Desire: Interventions<br/>from Queer Latino America</em><br/>José Quiroga</p>
<p class="noindentfs"><em>Murdering Masculinities: Fantasies of Gender<br/>and Violence in the American Crime Novel</em><br/>Greg Forter</p>
<p class="noindentfs"><em>Our Monica, Ourselves: The Clinton<br/>Affair and the National Interest</em><br/>Edited by Lauren Berlant and Lisa Duggan</p>
<p class="noindentfs"><em>Black Gay Man: Essays</em><br/>Robert Reid-Pharr<br/><em>Foreword by Samuel R. Delany</em></p>
<p class="noindentfs"><em>Passing: Identity and Interpretation<br/>in Sexuality, Race, and Religion</em><br/>Edited by María Carla Sánchez<br/>and Linda Schlossberg</p>
<p class="noindentfs"><em>The Explanation for Everything:<br/>Essays on Sexual Subjectivity</em><br/>Paul Morrison</p>
<p class="noindentfs"><em>The Queerest Art: Essays on<br/>Lesbian and Gay Theater</em><br/>Edited by Alisa Solomon and Framji Minwalla</p>
<p class="noindentfs"><em>Queer Globalizations: Citizenship<br/>and the Afterlife of Colonialism</em><br/>Edited by Arnaldo Cruz Malavé<br/>and Martin F. Manalansan IV</p>
<p class="noindentfs"><em>Queer Latinidad: Identity<br/>Practices, Discursive Spaces</em><br/>Juana María Rodríguez</p>
<p class="noindentfs"><em>Love the Sin: Sexual Regulation and<br/>the Limits of Religious Tolerance</em><br/>Janet R. Jakobsen and Ann Pellegrini</p>
<p class="noindentfs"><em>Boricua Pop: Puerto Ricans and the<br/>Latinization of American Culture</em><br/>Frances Négron-Muntaner</p>
<p class="noindentfs"><em>Manning the Race: Reforming Black<br/>Men in the Jim Crow Era</em><br/>Marlon Ross</p>
<p class="noindentfs"><em>In a Queer Time and Place: Transgender<br/>Bodies, Subcultural Lives</em><br/>Judith Halberstam</p>
<p class="noindentfs"><em>Why I Hate Abercrombie and Fitch:<br/>Essays on Race and Sexuality</em><br/>Dwight A. McBride</p>
<p class="noindentfs"><em>God Hates Fags: The Rhetorics<br/>of Religious Violence</em><br/>Michael Cobb</p>
<p class="noindentfs"><em>Once You Go Black: Choice, Desire, and<br/>the Black American Intellectual</em><br/>Robert Reid-Pharr</p>
<p class="noindentfs"><em>The Latino Body: Crisis Identities in<br/>American Literary and Cultural Memory</em><br/>Lázaro Lima</p>
<p class="noindentfs"><em>Arranging Grief: Sacred Time and the<br/>Body in Nineteenth-Century America</em><br/>Dana Luciano</p>
<p class="noindentfs"><em>Cruising Utopia: The Then and<br/>There of Queer Futurity</em><br/>José Esteban Muñoz</p>
<p class="noindentfs"><em>Another Country: Queer Anti-Urbanism</em><br/>Scott Herring</p>
<p class="noindentfs"><em>Extravagant Abjection: Blackness,<br/>Power, and Sexuality in the African<br/>American Literary Imagination</em><br/>Darieck Scott</p>
<p class="noindentfs"><em>Relocations: Queer Suburban Imaginaries</em><br/>Karen Tongson</p>
<p class="noindentfs"><em>Beyond the Nation: Diasporic Filipino<br/>Literature and Queer Reading</em><br/>Martin Joseph Ponce</p>
<p class="noindentfs"><em>Single: Arguments for the Uncoupled</em><br/>Michael Cobb</p>
<p class="noindentfs"><em>Brown Boys and Rice Queens: Spellbinding<br/>Performance in the Asias</em><br/>Eng-Beng Lim</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?1fed037a